import React from "react";

import { forceArray } from "/lib/helsecore/forceArray";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent
} from "@hdir/ui/accordion";
import SideMenuItemLink from "./SideMenuItemLink";

import type { SideMenuItemProps } from "../types.d";

export default function SideMenuItemWithAccordion(props: SideMenuItemProps) {
  const {
    item, activeKey, linkProps, useHierarchicalNumbering, openByDefault
  } = props;

  const children = item?.children ? forceArray(item.children) : [];
  const isActive = activeKey === item.link;
  const containsActivePage = children.some((child) => child.link === activeKey);
  const isOpen = openByDefault || isActive || containsActivePage;

  return (
    <li className="nt-border-x-0">
      <Accordion defaultValue={isOpen ? [item.link] : []}>
        <AccordionItem className="!border-0" value={item.link}>
          <AccordionTrigger
            customTrigger={{ closedText: "Vis underkapitler", expandedText: "Skjul underkapitler", variant: "secondary" }}
            className={`${isActive ? "selected" : "!bg-neutral"} sidemenu-accordion-trigger`}
          >
            <SideMenuItemLink {...props} />
          </AccordionTrigger>
          <AccordionContent className="!p-0">
            <ol className="list-none m-0 p-0">
              {children.map((child) => (
                <li key={child.link} className="nt-border-x-0">
                  <SideMenuItemLink
                    className="!pl-xl !pr-xs !py-sm"
                    item={child}
                    activeKey={activeKey}
                    linkProps={linkProps}
                    useHierarchicalNumbering={useHierarchicalNumbering}
                  />
                </li>
              ))}
            </ol>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </li>
  );
}
